export const URLS = {
  critter: "critter/",
  critterList: "list/",
  usercustom: "usercustom/",
}
